const tr = {
  common: {
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    close: 'Kapat',
    update: 'Güncelle',
    updating: 'Güncelleniyor...',
    saving: 'Kaydediliyor...',
    loading: 'Yükleniyor...',
    search: 'Arama:',
    all: 'Tümü',
    actions: 'İşlemler',
    notes: 'Not',
    date: 'Tarih',
    time: 'Saat',
    status: 'Durum',
    total: 'Toplam',
    today: 'Bugün',
    tomorrow: 'Yarın',
    thisWeek: 'Bu Hafta',
    thisMonth: 'Bu Ay',
    thisYear: 'Bu Yıl',
    logout: 'Çıkış Yap',
    login: 'Giriş Yap',
    email: 'E-posta',
    password: 'Şifre',
    developedBy: 'Developed by',
    allRightsReserved: 'Tüm hakları saklıdır.',
    required: 'Zorunlu',
    optional: 'Opsiyonel',
    filter: 'Filtrele',
    clear: 'Temizle',
    details: 'Detay',
    print: 'Yazdır',
    downloadPdf: 'PDF İndir',
    whatsapp: 'WhatsApp',
    call: 'Ara',
    yes: 'Evet',
    no: 'Hayır',
    back: 'Geri',
    next: 'İleri',
    success: 'Başarılı',
    error: 'Hata',
    warning: 'Uyarı',
    info: 'Bilgi',
    confirm: 'Onayla',
    backToHome: 'Ana Sayfaya Dön',
    ok: 'Tamam',
    add: 'Ekle',
    saveSettings: 'Ayarları Kaydet'
  },

  nav: {
    title: 'Ebrar Gordijnen - Müşteri Listesi',
    home: 'Ana Sayfa',
    planning: 'Planlama',
    customers: 'Müşteri Listesi',
    installationList: 'Montaj Listesi',
    users: 'Kullanıcılar',
    products: 'Ürün Listesi',
    accounting: 'Hesaplamalar'
  },

  header: {
    title: 'Ebrar Gordijnen - Müşteri Listesi',
    checkPermissions: 'Yetkiler Kontrol Ediliyor...',
    selectLanguage: 'Dil Seçin'
  },

  customer: {
    add: '+ Yeni Müşteri',
    customerInfo: 'Müşteri Bilgileri',
    name: 'Ad Soyad',
    phone1: 'Telefon 1',
    phone2: 'Telefon 2',
    address: 'Adres',
    city: 'Şehir',
    cityOptional: 'Şehir (Opsiyonel)',
    cityPlaceholder: 'Örn: Utrecht, Den Haag...',
    postalCode: 'Posta Kodu',
    postalCodeOptional: 'Posta Kodu (Opsiyonel)',
    postalCodePlaceholder: 'Örn: 3512 JE',
    notes: 'Not',
    inspectionDate: 'Keşif Tarihi & Saati',
    inspectionCompleted: 'Keşif Yapıldı',
    inspectionUndo: 'Geri Al',
    inspectionToggleHint: 'İşaretlendiğinde keşif anasayfadaki aktif hatırlatıcı listesinden kaldırılır',
    orderDate: 'Sipariş Tarihi',
    deliveryDate: 'Teslimat Tarihi & Saati',
    orderStatus: 'Sipariş Durumu',
    paidAmount: 'Alınan Ödeme',
    remainingAmount: 'Kalan Tutar',
    paymentCompleted: 'Ödeme Tamamlandı',
    paymentType: 'Ödeme Tipi',
    orders: 'Siparişler',
    addOrder: '+ Sipariş Ekle',
    deleteConfirm: 'Bu müşteriyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!',
    totalOrders: 'Toplam Sipariş',
    totalPrice: 'Toplam Tutar',
    searchPlaceholder: 'Müşteri adı, telefon veya adres...',
    itemsPerPage: 'Sayfa Başına:',
    tableView: 'Tablo Görünümü',
    cardView: 'Kart Görünümü',
    noCustomersFound: 'Kayıtlı müşteri bulunamadı.',
    stepCustomer: '1. Müşteri Bilgileri',
    stepOrder: '2. Sipariş Detayı',
    goToOrderStep: 'Sipariş Bilgilerine Geç',
    saveOnlyCustomer: 'Sadece Müşteriyi Kaydet'
  },

  orderStatus: {
    new_order: 'Yeni Sipariş',
    firma: 'Firma',
    atolye: 'Atölye',
    montaj: 'Montaj',
    delivered: 'Teslim Edildi'
  },

  paymentType: {
    cash: 'Elden Nakit',
    iban: 'IBAN',
    bank_card: 'Banka Kartı',
    credit_card: 'Kredi Kartı'
  },

  productTypes: {
    tul: 'Tül',
    kanat: 'Kanat',
    stor: 'Stor',
    zebra: 'Zebra',
    ahsapJaluzi: 'Ahşap Jaluzi',
    metalJaluzi: 'Metal Jaluzi',
    dikeyPerde: 'Dikey Perde',
    dikeyPvc: 'Dikey PVC',
    dikeyStor: 'Dikey Stor',
    plise: 'Plise',
    katlamaliPerde: 'Katlamalı Perde',
    raySistemi: 'Ray Sistemleri',
    rustik: 'Rustik',
    aksesuar: 'Aksesuar'
  },

  productForm: {
    roomName: 'Oda Adı',
    roomPlaceholder: 'Örn: Salon, Yatak Odası',
    productType: 'Ürün Tipi',
    productName: 'Ürün Adı',
    productVariant: 'Ürün Varyantı',
    width: 'En (cm)',
    height: 'Boy (cm)',
    unitPrice: 'Birim Fiyat (€)',
    quantity: 'Adet',
    pileModel: 'Pile Modeli',
    pileDensity: 'Pile Sıklığı',
    twoPiecesCenter: 'Ortadan iki parça olacak',
    twoPiecesAlert: 'Atölye uyarısı: 2 parça üretilecektir (+50 cm kumaş eklendi)',
    bottomHem: 'Alt Etek Katlama',
    usedM2: 'Kullanılan Metrekare (m²)',
    usedMeter: 'Kullanılan Metre',
    totalPrice: 'Toplam Fiyat (€)',
    discount: 'İndirim (%)',
    discountedPrice: 'İndirimli Fiyat (€)',
    direction: 'Yön',
    directionLeft: 'Sol',
    directionRight: 'Sağ',
    directionCenter: 'Ortadan açılım',
    mounting: 'Montaj',
    mountingIncluded: 'Montaj Dahil',
    saveProduct: 'Ürünü Kaydet',
    addProduct: '+ Ürün Ekle',
    accessories: 'Aksesuarlar',
    notes: 'Ürün Notları',
    deleteProductConfirm: 'Bu ürünü silmek istediğinize emin misiniz?'
  },

  orderSummary: {
    subtotal: 'Ara Toplam',
    discountedSubtotal: 'Ürün İndirimli Toplam',
    generalDiscount: 'Genel İskonto (%)',
    discountedTotal: 'İskontolu Toplam',
    grandTotal: 'Genel Toplam (Net)',
    paymentCompleted: 'Ödeme Tamamlandı',
    totalPaid: 'Toplam Ödenen',
    remainingPayment: 'Kalan Ödeme',
    paymentReceived: 'Ödeme Alındı',
    paymentType: 'Ödeme Tipi:',
    paymentDate: 'Ödeme Tarihi:',
    completePayment: 'Ödemeyi Tamamla',
    cancel: 'Vazgeç',
    newPayment: 'Yeni Ödeme Ekle',
    amount: 'Tutar (€):',
    add: 'Ekle',
    paymentHistory: 'Ödeme Geçmişi',
    cancelPayment: 'İptal',
    savePricing: 'Fiyat Bilgilerini Kaydet',
    saving: 'Kaydediliyor...'
  },

  dashboard: {
    customerStats: 'Müşteri İstatistikleri',
    revenueStats: 'Ciro & Finansal Özet',
    totalCustomers: 'Toplam Müşteri',
    activeCustomers: 'Aktif Müşteri',
    expectedRevenue: 'Beklenen Gelir',
    totalRevenue: 'Toplam Gelir',
    remainingBalance: 'Kalan Ödemeler',
    collectedRevenue: 'Tahsil Edilen Ciro',
    remainingRevenue: 'Kalan Alacaklar',
    today: 'Bugün',
    thisWeek: 'Bu Hafta',
    thisMonth: 'Bu Ay',
    thisYear: 'Bu Yıl',
    monthlyCustomerTrend: 'Aylık Müşteri Trendi',
    monthlyOrderTrend: 'Aylık Sipariş Trendi',
    monthlyEarningsTrend: 'Aylık Kazanç Trendi',
    customer: 'Müşteri',
    order: 'Sipariş',
    earnings: 'Kazanç',
    lastYearComparison: 'Geçen Yıl Karşılaştırması',
    lastYearToday: 'Geçen Yıl Bugün',
    lastYearThisWeek: 'Geçen Yıl Bu Hafta',
    lastYearThisMonth: 'Geçen Yıl Bu Ay',
    lastYearTotal: 'Geçen Yıl Toplam',
    sameDayCustomers: 'Aynı gün müşteri sayısı',
    sameWeekCustomers: 'Aynı hafta müşteri sayısı',
    sameMonthCustomers: 'Aynı ay müşteri sayısı',
    yearTotalCustomers: 'Yıl boyunca toplam',
    paymentBreakdown: 'Ödeme Tipine Göre',
    todayCash: 'Bugün (Nakit)',
    todayIban: 'Bugün (IBAN)',
    todayCard: 'Bugün (Banka Kartı)',
    cashDesc: 'Elden nakit ödemeler',
    ibanDesc: 'Banka transferi',
    cardDesc: 'Banka kartı ile ödemeler',
    dataManagement: 'Veri Yönetimi',
    backupExport: 'Yedek Al',
    backupExportDesc: 'Tüm müşteri ve sipariş verilerinizi JSON formatında yedekleyin',
    exporting: 'Yedekleniyor...',
    backupImport: 'Yedek Yükle',
    backupImportDesc: 'Daha önce aldığınız backup dosyasını geri yükleyin',
    backupNotice: 'Önemli: Yedek yükleme işlemi mevcut verilerinizi silmez. Aynı ID\'ye sahip veriler güncellenir, yeni veriler eklenir.',
    companyInfo: 'Firma Bilgileri',
    show: 'Göster',
    hide: 'Gizle',
    companyName: 'Firma Adı *',
    companyNamePlaceholder: 'Firma adını girin',
    companyPhone: 'Telefon Numarası *',
    companyPhoneHint: 'Ülke kodu ile birlikte girin (örn: 905321234567)',
    registeredCompanies: 'Kayıtlı Firmalar',
    noCompanies: 'Henüz firma eklenmemiş.',
    companyInfoNotice: 'Bilgi: Eklediğiniz firmalar WhatsApp mesaj gönderme bölümünde görünecektir.',
    changePassword: 'Şifre Değiştir',
    currentPassword: 'Mevcut Şifre *',
    currentPasswordPlaceholder: 'Mevcut şifrenizi girin',
    newPassword: 'Yeni Şifre *',
    newPasswordPlaceholder: 'Yeni şifrenizi girin (en az 6 karakter)',
    newPasswordHint: 'En az 6 karakter olmalıdır',
    confirmPassword: 'Yeni Şifre Tekrar *',
    confirmPasswordPlaceholder: 'Yeni şifrenizi tekrar girin',
    changingPassword: 'Değiştiriliyor...',
    cacheRefresh: 'Verileri Yenile',
    cacheLastUpdated: 'Son Güncelleme:'
  },

  planning: {
    title: 'Randevu, Keşif & Rota Planlama Merkezi',
    subtitle: 'Keşif ve montaj randevularını bölgelerine göre gruplayın, Google Haritalar rotalarıyla optimize edin.',
    regionalPlanner: 'Bölge & Rota Planlayıcı',
    timeline: 'Ajanda (Zaman Çizelgesi)',
    montajTab: 'Teslimat / Montaj',
    kesifTab: 'Keşif / Ölçüm',
    mapPinsTab: 'Harita & Pinler',
    routeFromLocation: 'Konumumdan Rota',
    routeFromStore: 'Mağazadan',
    listStops: 'Durakları Listele',
    closeStops: 'Durakları Kapat',
    goToStop: 'Konumdan Git',
    allPins: 'Tümünü Haritada Aç',
    pinKesif: 'Keşifleri Pinle',
    pinMontaj: 'Montajları Pinle',
    sameDayOpportunity: 'Aynı Gün Fırsatı!',
    overdue: 'Gecikmiş Randevular',
    today: 'Bugün',
    tomorrow: 'Yarın',
    thisWeek: 'Bu Hafta',
    upcoming: 'Gelecek Randevular',
    completedInspections: 'Tamamlanan Keşifler',
    showCompleted: 'Tamamlananları Göster',
    noAppointments: 'Filtreye uygun planlanmış randevu bulunamadı.',
    searchPlaceholder: 'Bölge, şehir veya müşteri ara...',
    filterAll: 'Tüm Zamanlar',
    filterToday: 'Sadece Bugün',
    filterWeek: 'Bu Hafta (7 Gün)',
    filterOverdue: 'Gecikenler',
    stopsSequence: 'Rota Durakları Sıralaması',
    stopsHint: 'Müşteriye gitmek için yanındaki "Konumdan Git" butonuna tıklayarak doğrudan navigasyon başlatabilirsiniz.',
    directions: 'Yol Tarifi'
  },

  userManagement: {
    title: 'Kullanıcı Yönetimi',
    subtitle: 'Sistem kullanıcılarını, rollerini ve erişim yetkilerini yönetin.',
    addUser: '+ Yeni Kullanıcı Ekle',
    name: 'Ad Soyad',
    email: 'E-posta',
    role: 'Rol',
    roles: {
      admin: 'Yönetici (Admin)',
      satisci: 'Satışçı',
      montajci: 'Montajcı',
      yazilimci: 'Yazılımcı'
    },
    rolePermissions: 'Rol Yetkileri',
    roleDescriptions: {
      admin: 'Tüm sisteme tam erişim. Kullanıcı oluşturma ve silme yetkisi.',
      satisci: "Müşteri ve sipariş ekleme, düzenleme, silme. Dashboard'a erişim yok.",
      montajci: 'Sadece montaj durumundaki siparişleri görme ve teslim edildi olarak işaretleme.',
      yazilimci: 'Tüm özelliklere erişim, ancak sadece kendi oluşturduğu verileri görme.'
    },
    permissions: 'Yetkiler',
    actions: 'İşlemler'
  },

  login: {
    title: 'Ebrar Gordijnen',
    subtitle: 'Uçtan Uca Müşteri ve Sipariş Yönetimi',
    emailLabel: 'E-posta',
    emailPlaceholder: 'ornek@ebrargordijnen.nl',
    passwordLabel: 'Şifre',
    passwordPlaceholder: '••••••••',
    submitBtn: 'Giriş Yap',
    loggingIn: 'Giriş Yapılıyor...',
    languageLabel: 'Dil / Taal:'
  },

  pileModels: {
    sPile: 'S Pile',
    americanTekli: 'Amerikan Tekli',
    american2: "Amerikan 2'li",
    american3: "Amerikan 3'lü",
    kapsul: 'Kapsül Pile',
    altEtekKatlama: 'Alt Etek Katlama'
  },

  productList: {
    title: 'Ürün Listesi',
    subtitle: 'Ürün tipine göre kategorize edilmiş ürün kataloğu',
    loading: 'Yükleniyor...',
    empty: 'Bu kategoride henüz ürün yok.',
    addFirstProduct: 'İlk ürünü ekle',
    searchPlaceholder: 'Ürün adıyla ara...',
    clearSearch: 'Aramayı temizle',
    resultsCount: 'sonuç',
    addNewProduct: 'Yeni Ürün Ekle',
    table: {
      rowNum: '#',
      productName: 'Ürün Adı',
      unitPrice: 'Birim Fiyat',
      unitPriceShort: 'Satış',
      merdivenIpli: 'M. İpli (Fiyat)',
      kurdeleli: 'Kurdeleli (Fiyat)',
      merdivenIpliReduktorlu: 'M. İpli Red. (Fiyat)',
      kurdelaliReduktorlu: 'Kur. Red. (Fiyat)',
      rusticProduct: 'Rustik Ürün',
      actions: 'İşlemler'
    },
    excel: {
      productUnit: 'ürün',
      import: "Excel'den Yükle",
      export: "Excel'e Aktar",
      clearList: 'Listeyi Temizle',
      clearConfirmTitle: 'Listeyi Temizle',
      clearConfirmMessage: 'DİKKAT! "{type}" kategorisindeki {count} ürünün TAMAMI silinecektir.\n\nBu işlem geri alınamaz. Emin misiniz?',
      noProductsToExport: 'Dışa aktarılacak ürün bulunamadı.',
      noProductsToDelete: 'Bu kategoride silinecek ürün bulunamadı.',
      deletedTitle: 'Temizlendi',
      deletedCount: '{count} ürün başarıyla silindi.',
      clearError: 'Liste temizlenirken bir hata oluştu: ',
      emptyOrUnreadable: 'Excel dosyası boş veya okunamadı.',
      invalidFormatTitle: 'Hatalı Format',
      invalidFormatMsg: 'Hatalı Excel formatı! Dosyada "Ürün Adı" ve "Birim Fiyat" başlıkları bulunmalıdır.\n\n(Lütfen taslağı görmek için önce "Excel\'e Aktar" diyerek örnek dosyayı indirin)',
      invalidFormatJaluziMsg: 'Hatalı Excel formatı! Ahşap/Metal Jaluzi dosyalarında "Ürün Adı", "Merdiven İpli", "Kurdeleli" gibi başlıklar bulunmalıdır.\n\n(Lütfen taslağı görmek için önce "Excel\'e Aktar" diyerek örnek dosyayı indirin)',
      importConfirmTitle: 'Excel Yükleme Onayı',
      importConfirmMsg: 'Excel dosyasındaki {count} ürün işlenecek:\n\n• Mevcut {existing} ürün içinden eşleşenler güncellenir\n• Listede olmayan yeni ürünler eklenir\n• Listede olup Excel\'de olmayan ürünlere dokunulmaz\n\nOnaylıyor musunuz?',
      updatedCount: '{count} ürün güncellendi',
      addedCount: '{count} yeni ürün eklendi',
      noChanges: 'Değişiklik yapılmadı.',
      parseErrorTitle: 'Parse Hatası',
      parseErrorMsg: 'Dosya okunurken bir hata oluştu.',
      readError: 'Excel dosyası okunurken bir hata oluştu: '
    },
    modal: {
      newProduct: 'Yeni Ürün Ekle',
      editProduct: 'Ürün Düzenle',
      productType: 'Ürün Tipi',
      productName: 'Ürün Adı',
      productNamePlaceholder: 'örn. Karya Düz Tül',
      dynamicPricing: 'Dinamik Fiyatlandırma',
      merdivenIpliPrice: 'Merdiven İpli Satış Fiyatı',
      kurdeleliPrice: 'Kurdeleli Satış Fiyatı',
      merdivenIpliReduktorluPrice: 'Merdiven İpli Redüktörlü Satış Fiyatı',
      kurdelaliReduktorluPrice: 'Kurdelalı Redüktörlü Satış Fiyatı',
      rustikInfo: 'Rustik ürünleri için fiyatlandırma, sipariş sırasında ayak ve aksesuarlar üzerinden otomatik hesaplanır. Burada sadece ürün adı girilmelidir.',
      unitPriceLabel: 'Birim Fiyat (Satış - €)',
      deleteTitle: 'Ürün Sil',
      deleteConfirmQuestion: 'adlı ürünü silmek istediğinizden emin misiniz?',
      deleteWarning: 'Bu işlem geri alınamaz.',
      confirmationNeeded: 'Onay Gerekiyor',
      yesUpload: 'Evet, Yükle',
      productUpdated: 'Ürün başarıyla güncellendi!',
      productAdded: 'Ürün başarıyla eklendi!',
      productSaveError: 'Ürün kaydedilirken bir hata oluştu: ',
      productDeleteError: 'Ürün silinirken hata: ',
      settingsSaved: 'Ayarlar başarıyla kaydedildi.',
      settingsSaveError: 'Ayarlar kaydedilirken bir hata oluştu.'
    },
    motorSettings: {
      title: 'Motor ve Kumanda Ayarları',
      subtitle: '3 ayrı motor firması için motor ve kumanda ücretleri',
      titleWithType: 'Motor ve Kumanda Ayarları ({type})',
      subtitleWithType: '{type} siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',
      titleSuffix: 'Motor ve Kumanda Ayarları',
      subtitleSuffix: 'siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',
      jaluziMotorTitle: 'Jaluzi Motor ve Kumanda Ayarları',
      jaluziMotorSubtitle: 'Jaluzi siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',
      company: 'Firma',
      firm: 'Firma {num}',
      motor: 'Motor',
      remote: 'Kumanda',
      motorPrice: 'Motor (€)',
      kumandaPrice: 'Kumanda (€)'
    },
    extraPrices: {
      pileExtraTitle: 'Pile Ek Ücret Ayarları',
      tulTitle: 'Tül Pile Ek Ücret Ayarları',
      tulSubtitle: 'Tül siparişlerinde kullanılacak pile ek ücret değerleri',
      kanatTitle: 'Kanat Pile Ek Ücret Ayarları',
      kanatSubtitle: 'Kanat siparişlerinde kullanılacak pile ek ücret değerleri',

      storMotorTitle: 'Stor Motor ve Kumanda Ayarları',
      storMotorSubtitle: 'Stor siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',
      zebraMotorTitle: 'Zebra Motor ve Kumanda Ayarları',
      zebraMotorSubtitle: 'Zebra siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',
      storTitle: 'Stor Perde Ücret Ayarları',
      storSubtitle: 'Stor siparişlerinde kullanılacak sistem ve aksesuar ek ücretleri',
      zebraTitle: 'Zebra Perde Ücret Ayarları',
      zebraSubtitle: 'Zebra siparişlerinde kullanılacak sistem ve aksesuar ek ücretleri',

      ahsapMotorTitle: 'Ahşap Jaluzi Motor ve Kumanda Ayarları',
      ahsapMotorSubtitle: 'Ahşap Jaluzi siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',
      metalMotorTitle: 'Metal Jaluzi Motor ve Kumanda Ayarları',
      metalMotorSubtitle: 'Metal Jaluzi siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',
      ahsapTitle: 'Ahşap Jaluzi Ek Ücretler',
      metalTitle: 'Metal Jaluzi Ek Ücretler',
      jaluziSubtitle: 'Ek hizmet ve sistem ücretleri',

      dikeyPerdeMotorTitle: 'Dikey Perde Motor ve Kumanda Ayarları',
      dikeyPerdeMotorSubtitle: 'Dikey Perde siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',
      dikeyPvcMotorTitle: 'Dikey PVC Motor ve Kumanda Ayarları',
      dikeyPvcMotorSubtitle: 'Dikey PVC siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',
      dikeyStorMotorTitle: 'Dikey Stor Motor ve Kumanda Ayarları',
      dikeyStorMotorSubtitle: 'Dikey Stor siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',

      katlamaliMotorTitle: 'Katlamalı Perde Motor ve Kumanda Ayarları',
      katlamaliMotorSubtitle: 'Katlamalı Perde siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',

      perdeExtraTitle: 'Perde Ücret Ayarları',
      jaluziExtraTitle: 'Jaluzi Ek Ücretler',
      jaluziExtraSubtitle: 'Ek hizmet ve sistem ücretleri'
    },
    orderMotor: {
      title: 'Motor & Kumanda Seçimi',
      company: 'Motor Firması',
      withoutMotor: 'Motorsuz',
      package: 'Motor / Kumanda Paketi',
      select: 'Seçiniz',
      motorTotal: 'Motor Toplam (€)',
      motor: 'Motor',
      remote: 'Kumanda',
      remoteIncluded: '✓ Kumanda ücreti dahil edildi'
    },
    extraFields: {
      wooden: 'Ahşap',
      metal: 'Metal',
      jumbo: 'Jumbo Sistem',
      altEtekDilim: 'Alt Etek Dilim',
      kapaliKasa: 'Kapalı Kasa',
      altEtekLazer: 'Alt Etek Lazer',
      dekoratifLama: 'Dekoratif Lama',
      dekoratifKasa: 'Dekoratif Kasa',
      altEtekBeyazIs: 'Alt Etek Beyaz İş',
      zigil: 'Zıgıl Sistem',
      zigilPiece: 'Zıgıl Sistem (Adet)',
      reduktorDiffM2: 'Redüktörlü Farkı (m²)',
      ikiCamArasiPiece: 'İki Cam Arası (Adet)'
    },
    dikeySettings: {
      fonTitle: 'Dikey Perde Fon Ayarları',
      fonSubtitle: 'Fon ücreti ve fon isimleri listesi',
      fonPriceM2: 'Dikey Perde Fon Ücreti (m²)',
      fonNamesList: 'Fon İsimleri Listesi',
      newFonPlaceholder: 'Yeni Fon Adı (Örn: Fon 1)',
      emptyList: 'Liste boş'
    },
    katlamaliSettings: {
      motorTitle: 'Katlamalı Perde Motor ve Kumanda Ayarları',
      motorSubtitle: 'Katlamalı Perde siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri',
      title: 'Katlamalı Perde Mekanizma Ayarları',
      subtitle: 'Mekanizma tipleri ve ücretleri',
      mechanismTypePlaceholder: 'Mekanizma Tipi (Örn: 5+1)',
      pricePlaceholder: 'Ücret',
      registeredMechanisms: 'Kayıtlı Mekanizma Tipleri',
      editingBadge: 'Düzenleniyor',
      emptyTitle: 'Henüz mekanizma tipi eklenmemiş.',
      emptyDesc: 'Yukarıdaki formu kullanarak ilk mekanizmayı ekleyebilirsiniz.'
    },
    rustikSettings: {
      title: 'Rustik Ayak Ücret Ayarları',
      defaultFootPrice: 'Varsayılan Ayak Ücreti',
      defaultFootPriceDesc: 'Rustik siparişlerinde kullanılacak standart ayak birim fiyatı. Bu değer sipariş formuna otomatik yansır.',
      footModelList: 'Ayak Model Listesi',
      footDiameterList: 'Ayak Çap Listesi',
      footLengthList: 'Ayak Uzunluk Listesi',
      footColorCodeList: 'Ayak Renk Kodu Listesi',
      newModelPlaceholder: 'Yeni Model (Örn: Model 1)',
      newDiameterPlaceholder: 'Yeni Çap (Örn: 28mm)',
      newLengthPlaceholder: 'Yeni Uzunluk (Örn: 15cm)',
      newColorPlaceholder: 'Yeni Renk (Örn: Siyah / Mat)'
    }
  }
};

export default tr;
